<template>
  <div v-if="allowedToShow"
       class="project-customer-table-cell">
    <v-avatar>
      <img v-if="customer.logoURL"
           class="avatar" :src="(customer.logoURL)">
      <v-icon v-else
              class="initials">{{initials}}</v-icon>
    </v-avatar>
    <div class="name">
      {{ customer.name }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectCustomerTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    customer() {
      return this.item.customer;
    },
    initials() {
      if (this.item.customer) {
        return this.item.customer.name[0].toUpperCase();
      }
      return null;
    },
    allowedToShow() {
      return this.customer;
    },
  },
};
</script>

<style lang="scss" scoped>
  .project-customer-table-cell {
    display: block;
  }

  .name {
    font-size: 14px;
    line-height: 20px;
    display: inline-block;
  }

  img.avatar {
    width: 24px;
    height: 24px;
    display: inline-block;
  }

  ::v-deep .v-avatar {
    min-width: 24px !important;
    width: 24px !important;
    min-height: 24px !important;
    height: 24px !important;
    margin: 8px 8px 8px 0;
  }

  .initials {
    background-color: rgba(14,31,51,0.15);
    border-radius: 50px;
    color: #4D9FEB;
    display: block;
    height: 24px;
    width: 24px;
    font-size: 14px;
    font-family: inter;
    padding-top: 5px;
  }

</style>
